import { createFileRoute } from "@tanstack/react-router";
import { WebFeedbackPage } from "@/features/webfeedback/WebFeedbackPage";

export const Route = createFileRoute("/_app/web-feedback/")({
  component: WebFeedbackPage,
});
